import { useCallback, type ChangeEventHandler } from "react";
import { useControlsInput } from "./controls/controls-provider";
import type { ControlMode } from "./controls/control-types";

/**
 * Debug control to switch between available controller schemes.
 */
export const DebugControllerToggle = () => {
  const { mode, setMode } = useControlsInput();
  const handleChange = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    (event) => {
      const next = event.target.value as ControlMode;
      console.log("[DebugControllerToggle] Switching control mode", next);
      setMode(next);
    },
    [setMode],
  );

  return (
    <div className="flex items-center gap-2 text-primary">
      <span className="opacity-80">Controller</span>
      <select
        aria-label="Debug: Controller Scheme"
        className="bg-transparent text-primary outline-none"
        value={mode}
        onChange={handleChange}
      >
        <option value="fps">fps</option>
        <option value="flight">flight</option>
      </select>
    </div>
  );
};

DebugControllerToggle.displayName = "DebugControllerToggle";
